import React, { useMemo, useState } from "react";

const CONTACT_OPTIONS = [
  {
    id: "atc",
    label: "Contactar con ATC",
    href:
      process.env.REACT_APP_WHATSAPP_ATC_LINK ||
      "https://wa.me/981317111",
  },
  {
    id: "soporte",
    label: "Contactar con Soporte",
    href:
      process.env.REACT_APP_WHATSAPP_SOPORTE_LINK ||
      "https://wa.me/984300325",
  },
];

const WhatsAppIcon = ({ className = "", size = 26 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="16" cy="16" r="16" fill="#25D366" />
    <path
      d="M22.6 18.5c-.3-.2-1.9-.9-2.1-1-.2-.1-.4-.2-.6.1-.2.3-.7 1-.9 1.2-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2.1-.4 0-.5 0-.1-.6-1.5-.8-2s-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s.9 2.6 1 2.7c.1.2 1.7 2.7 4.1 3.8.6.3 1 .5 1.4.6.6.2 1.1.2 1.5.1.4-.1 1.9-.8 2.1-1.4.3-.6.3-1.1.2-1.2-.1-.1-.3-.2-.6-.3z"
      fill="#fff"
    />
  </svg>
);

export default function FloatingWhatsApp() {
  const [expanded, setExpanded] = useState(false);
  const handleMouseEnter = () => setExpanded(true);
  const handleMouseLeave = () => setExpanded(false);
  const handleFocus = () => setExpanded(true);
  const handleBlur = () => setExpanded(false);

  const optionStyleBase = useMemo(
    () =>
      "flex items-center gap-3 rounded-xl bg-white/95 px-4 py-2.5 text-sm shadow-lg ring-1 ring-black/5 backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2",
    []
  );

  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex flex-col items-end"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <div
        className={`mb-3 flex flex-col gap-2 transition-all duration-200 ${
          expanded
            ? "pointer-events-auto translate-y-0 opacity-100"
            : "pointer-events-none translate-y-2 opacity-0"
        }`}
      >
        {CONTACT_OPTIONS.map((option, index) => (
          <a
            key={option.id}
            href={option.href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              transitionDelay: expanded ? `${index * 80}ms` : "0ms",
            }}
            className={`${optionStyleBase} ${
              expanded ? "translate-x-0 opacity-100" : "translate-x-2 opacity-0"
            }`}
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-green-500 to-green-400 text-white shadow-inner">
              <WhatsAppIcon size={18} className="drop-shadow" />
            </span>
            <span className="whitespace-nowrap text-gray-800">{option.label}</span>
          </a>
        ))}
      </div>

      <button
        type="button"
        onMouseEnter={handleMouseEnter}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className="relative flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-green-500 via-green-500 to-emerald-500 text-white shadow-[0_10px_25px_-10px_rgba(16,185,129,0.9)] transition-transform duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
        aria-label="Contactar por WhatsApp"
        aria-expanded={expanded}
      >
        <WhatsAppIcon size={26} />
        <span
          className={`pointer-events-none absolute inset-0 rounded-full transition-opacity duration-200 ${
            expanded ? "opacity-0" : "opacity-40"
          }`}
          style={{
            background: "radial-gradient(circle, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 70%)",
          }}
          aria-hidden="true"
        />
      </button>
    </div>
  );
}
